import { useOrchestrator } from '../core/context';
export function useOrchestratorNavigation() {
  const {
    next,
    skip,
    back,
    canGoBack,
    canGoNext,
    currentFlowIndex,
    currentStepIndex,
    totalSteps,
    isComplete,
    isFirstStep,
    isLastStep,
    progress,
    isLoading,
    navigate,
    goToIndex,
    goToStepId,
    goToStepIndex,
    reset
  } = useOrchestrator();
  return {
    next,
    skip,
    back,
    canGoBack,
    canGoNext,
    currentFlowIndex,
    currentStepIndex,
    totalSteps,
    isComplete,
    isFirstStep,
    isLastStep,
    progress,
    isLoading,
    navigate,
    goToIndex,
    goToStepId,
    goToStepIndex,
    reset
  };
}
//# sourceMappingURL=useOrchestratorNavigation.js.map